import e, { useRef as t, useState as r, useLayoutEffect as n } from "react";
import { componentName as o } from "../../../utils/bem/index.js";
import { Tooltip as i } from "../../forms/Tooltip/Tooltip.js";
import "../../../../node_modules/classnames/index.js";
function c(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function l(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r,
      n,
      o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != o) {
      var i = [],
        c = !0,
        l = !1;
      try {
        for (o = o.call(e); !(c = (r = o.next()).done) && (i.push(r.value), !t || i.length !== t); c = !0);
      } catch (e) {
        l = !0, n = e;
      } finally {
        try {
          c || null == o.return || o.return();
        } finally {
          if (l) throw n;
        }
      }
      return i;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return c(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return c(e, t);
    }
  }(e, t) || function () {
    throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function a(c) {
  var a,
    u,
    f,
    s = c.text,
    p = c.maxLines,
    m = void 0 === p ? 1 : p,
    y = c.className,
    b = c.onClampOrResize,
    O = c.tooltipOptions,
    d = c.style,
    g = t(),
    v = l(r(s), 2),
    h = v[0],
    j = v[1],
    w = l(r(!1), 2),
    P = w[0],
    x = w[1],
    S = o("text-truncate", y, {
      clamped: h !== s,
      "singleline-truncated": P || 1 === m
    });
  function E(e) {
    g.current.innerHTML = e;
  }
  function A(e) {
    j(e), null == b || b(e);
  }
  function T() {
    if (g.current) {
      if (g.current.clientWidth < g.current.scrollWidth) {
        x(!0), A(s);
        return;
      }
      if (1 === m) {
        A(s);
        return;
      }
      E(".");
      for (var e = g.current.clientHeight * m, t = 1; t <= s.length; t++) if (E(s.slice(0, t)), g.current.clientHeight > e) {
        t--;
        break;
      }
      if (t === s.length + 1) E(s), h !== s && A(s);else {
        var r = s.slice(0, Math.max(t - 3, 0)).trimEnd() + "...";
        E(r), A(r);
      }
    }
  }
  return n(function () {
    T();
    var e = new ResizeObserver(T);
    return e.observe(g.current), function () {
      e.disconnect();
    };
  }, [s, m, y, d]), e.createElement(e.Fragment, null, e.createElement("div", {
    ref: g,
    className: S,
    style: d
  }, h), (h !== s || P) && e.createElement(i, (a = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(r);
      "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
        return Object.getOwnPropertyDescriptor(r, e).enumerable;
      }))), n.forEach(function (t) {
        var n;
        n = r[t], t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n;
      });
    }
    return e;
  }({}, O), u = u = {
    content: s,
    target: null !== (f = null == O ? void 0 : O.target) && void 0 !== f ? f : g.current
  }, Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(u)) : function (e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      r.push.apply(r, n);
    }
    return r;
  }(Object(u)).forEach(function (e) {
    Object.defineProperty(a, e, Object.getOwnPropertyDescriptor(u, e));
  }), a)));
}
export { a as default };